/* Skeleton placeholder matching the FeedItemRow layout, shown while feed data loads.
   Heights must match real row text line-heights to prevent layout shift. */

import { Skeleton } from "@/components/ui/skeleton";

export function FeedItemRowSkeleton() {
  return (
    <div className="flex items-start gap-2.5 px-4 py-2">
      <Skeleton className="w-[122px] h-[68px] rounded-sm shrink-0" />
      <div className="flex flex-col gap-2 flex-1 min-w-0 pt-0.5">
        <Skeleton className="h-5 w-3/4 rounded-sm" />
        <Skeleton className="h-4 w-1/3 rounded-sm" />
        <Skeleton className="h-4 w-1/4 rounded-sm" />
      </div>
    </div>
  );
}
